/**
 * ============================================================================
 * PRODUCT CATALOG v2.3 - VOLLSTÄNDIG ERWEITERT
 * ============================================================================
 *
 * Vordefinierter Produktkatalog für die Artikelauswahl.
 * Kategorisierte Produkte mit Standardmengen und Einheiten.
 *
 * ✅ v2.3: VOLLSTÄNDIG ERWEITERT (7 weitere Kategorien)
 *    - Reise & Gepäck (Koffer, Accessoires, Reise-Hygiene)
 *    - Spielzeug & Spiele (Klassiker, Kreativ, Outdoor, Puppen, Elektronisch)
 *    - Musik & Instrumente (Saiten, Blas, Schlag, Tasten, Audio)
 *    - Garten erweitert (Pflanzen, Dünger, Bewässerung, Werkzeug, Schädlinge)
 *    - Heimwerker-Elektrik (Klemmen, Kabel, Steckdosen, Schalter, Sicherheit)
 *    - Textilien & Nähen (Nähzubehör, Verschlüsse, Stoffe, Handarbeit)
 *    - Camping & Outdoor (Unterkunft, Kochen, Licht, Sicherheit, Kleidung)
 *
 * ✅ v2.2: KOMPLETT ERWEITERT (7 neue Kategorien)
 *    - Bürobedarf, Sport & Fitness, Auto & Motorrad
 *    - Schule & Lernen, Party & Deko, Möbel & Wohnen, Saisonware
 *
 * ✅ v2.1: BAUMARKT & ELEKTROGERÄTE
 *    - Neue Kategorie: Baumarkt (Werkzeuge, Farben, Garten)
 *    - Neue Kategorie: Elektrogeräte (Küche, Haushalt, Beleuchtung)
 *
 * ✅ v2.0: ERWEITERT
 *    - Mehr Produkte pro Kategorie
 *    - Neue Kategorie: Baby & Kinder
 *    - Neue Kategorie: Drogerie & Gesundheit
 *
 * @version 2.3.0
 */

export const PRODUCT_CATALOG = {
  'obst-gemuese': {
    id: 'obst-gemuese',
    label: 'Obst & Gemüse',
    emoji: '🥬',
    products: [
      // Obst
      { id: 'apfel', name: 'Äpfel', emoji: '🍎', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'banane', name: 'Bananen', emoji: '🍌', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'orange', name: 'Orangen', emoji: '🍊', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'zitrone', name: 'Zitronen', emoji: '🍋', defaultQty: 3, defaultUnit: 'Stück' },
      { id: 'limette', name: 'Limetten', emoji: '🍋', defaultQty: 3, defaultUnit: 'Stück' },
      { id: 'weintraube', name: 'Weintrauben', emoji: '🍇', defaultQty: 500, defaultUnit: 'g' },
      { id: 'erdbeere', name: 'Erdbeeren', emoji: '🍓', defaultQty: 500, defaultUnit: 'g' },
      { id: 'himbeere', name: 'Himbeeren', emoji: '🍇', defaultQty: 125, defaultUnit: 'g' },
      { id: 'blaubeere', name: 'Blaubeeren', emoji: '🫐', defaultQty: 125, defaultUnit: 'g' },
      { id: 'kirsche', name: 'Kirschen', emoji: '🍒', defaultQty: 500, defaultUnit: 'g' },
      { id: 'pfirsich', name: 'Pfirsiche', emoji: '🍑', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'nektarine', name: 'Nektarinen', emoji: '🍑', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'pflaume', name: 'Pflaumen', emoji: '🍑', defaultQty: 500, defaultUnit: 'g' },
      { id: 'birne', name: 'Birnen', emoji: '🍐', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'mango', name: 'Mango', emoji: '🥭', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ananas', name: 'Ananas', emoji: '🍍', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kiwi', name: 'Kiwi', emoji: '🥝', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'melone', name: 'Wassermelone', emoji: '🍉', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'honigmelone', name: 'Honigmelone', emoji: '🍈', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'grapefruit', name: 'Grapefruit', emoji: '🍊', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'granatapfel', name: 'Granatapfel', emoji: '🍎', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'feige', name: 'Feigen', emoji: '🍇', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'datteln', name: 'Datteln', emoji: '🍇', defaultQty: 200, defaultUnit: 'g' },
      // Gemüse
      { id: 'karotte', name: 'Karotten', emoji: '🥕', defaultQty: 500, defaultUnit: 'g' },
      { id: 'kartoffel', name: 'Kartoffeln', emoji: '🥔', defaultQty: 2, defaultUnit: 'kg' },
      { id: 'suesskartoffel', name: 'Süßkartoffeln', emoji: '🥔', defaultQty: 500, defaultUnit: 'g' },
      { id: 'tomate', name: 'Tomaten', emoji: '🍅', defaultQty: 500, defaultUnit: 'g' },
      { id: 'cherrytomaten', name: 'Cherrytomaten', emoji: '🍅', defaultQty: 250, defaultUnit: 'g' },
      { id: 'gurke', name: 'Gurke', emoji: '🥒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zwiebel', name: 'Zwiebeln', emoji: '🧅', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'rote-zwiebel', name: 'Rote Zwiebeln', emoji: '🧅', defaultQty: 500, defaultUnit: 'g' },
      { id: 'fruehlingszwiebel', name: 'Frühlingszwiebeln', emoji: '🧅', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'lauch', name: 'Lauch', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'knoblauch', name: 'Knoblauch', emoji: '🧄', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ingwer', name: 'Ingwer', emoji: '🧄', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'salat', name: 'Salat', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'eisbergsalat', name: 'Eisbergsalat', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rucola', name: 'Rucola', emoji: '🥬', defaultQty: 100, defaultUnit: 'g' },
      { id: 'feldsalat', name: 'Feldsalat', emoji: '🥬', defaultQty: 100, defaultUnit: 'g' },
      { id: 'paprika', name: 'Paprika', emoji: '🫑', defaultQty: 3, defaultUnit: 'Stück' },
      { id: 'paprika-rot', name: 'Paprika rot', emoji: '🫑', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'paprika-gelb', name: 'Paprika gelb', emoji: '🫑', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'paprika-gruen', name: 'Paprika grün', emoji: '🫑', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'chili', name: 'Chili', emoji: '🌶️', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'zucchini', name: 'Zucchini', emoji: '🥒', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'aubergine', name: 'Aubergine', emoji: '🍆', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'brokkoli', name: 'Brokkoli', emoji: '🥦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'blumenkohl', name: 'Blumenkohl', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rosenkohl', name: 'Rosenkohl', emoji: '🥬', defaultQty: 500, defaultUnit: 'g' },
      { id: 'spinat', name: 'Spinat', emoji: '🥬', defaultQty: 200, defaultUnit: 'g' },
      { id: 'mangold', name: 'Mangold', emoji: '🥬', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'grünkohl', name: 'Grünkohl', emoji: '🥬', defaultQty: 500, defaultUnit: 'g' },
      { id: 'rotkohl', name: 'Rotkohl', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'weisskohl', name: 'Weißkohl', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'chinakohl', name: 'Chinakohl', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kohlrabi', name: 'Kohlrabi', emoji: '🥬', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'sellerie', name: 'Sellerie', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'stangensellerie', name: 'Stangensellerie', emoji: '🥬', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'fenchel', name: 'Fenchel', emoji: '🥬', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'champignon', name: 'Champignons', emoji: '🍄', defaultQty: 250, defaultUnit: 'g' },
      { id: 'pfifferlinge', name: 'Pfifferlinge', emoji: '🍄', defaultQty: 200, defaultUnit: 'g' },
      { id: 'avocado', name: 'Avocado', emoji: '🥑', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'mais', name: 'Mais', emoji: '🌽', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'erbsen', name: 'Erbsen', emoji: '🟢', defaultQty: 300, defaultUnit: 'g' },
      { id: 'bohnen-gruen', name: 'Grüne Bohnen', emoji: '🫛', defaultQty: 500, defaultUnit: 'g' },
      { id: 'spargel', name: 'Spargel', emoji: '🥬', defaultQty: 500, defaultUnit: 'g' },
      { id: 'radieschen', name: 'Radieschen', emoji: '🥕', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'rettich', name: 'Rettich', emoji: '🥕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rote-bete', name: 'Rote Bete', emoji: '🥕', defaultQty: 500, defaultUnit: 'g' },
      { id: 'kuerbis', name: 'Kürbis', emoji: '🎃', defaultQty: 1, defaultUnit: 'Stück' },
      // Kräuter
      { id: 'petersilie', name: 'Petersilie', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'schnittlauch', name: 'Schnittlauch', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'dill', name: 'Dill', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'koriander', name: 'Koriander', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'minze', name: 'Minze', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'rosmarin', name: 'Rosmarin', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
      { id: 'thymian', name: 'Thymian', emoji: '🌿', defaultQty: 1, defaultUnit: 'Bund' },
    ]
  },
  'milchprodukte': {
    id: 'milchprodukte',
    label: 'Milchprodukte',
    emoji: '🥛',
    products: [
      { id: 'milch', name: 'Milch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'milch-haltbar', name: 'H-Milch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'milch-laktosefrei', name: 'Laktosefreie Milch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'hafermilch', name: 'Hafermilch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'mandelmilch', name: 'Mandelmilch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'sojamilch', name: 'Sojamilch', emoji: '🥛', defaultQty: 1, defaultUnit: 'L' },
      { id: 'kokosmilch', name: 'Kokosmilch', emoji: '🥥', defaultQty: 400, defaultUnit: 'ml' },
      { id: 'butter', name: 'Butter', emoji: '🧈', defaultQty: 250, defaultUnit: 'g' },
      { id: 'margarine', name: 'Margarine', emoji: '🧈', defaultQty: 500, defaultUnit: 'g' },
      { id: 'kaese', name: 'Käse', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'gouda', name: 'Gouda', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'emmentaler', name: 'Emmentaler', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'edamer', name: 'Edamer', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'camembert', name: 'Camembert', emoji: '🧀', defaultQty: 125, defaultUnit: 'g' },
      { id: 'brie', name: 'Brie', emoji: '🧀', defaultQty: 125, defaultUnit: 'g' },
      { id: 'feta', name: 'Feta', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'ziegenkaese', name: 'Ziegenkäse', emoji: '🧀', defaultQty: 150, defaultUnit: 'g' },
      { id: 'joghurt', name: 'Joghurt', emoji: '🥛', defaultQty: 500, defaultUnit: 'g' },
      { id: 'joghurt-griechisch', name: 'Griechischer Joghurt', emoji: '🥛', defaultQty: 400, defaultUnit: 'g' },
      { id: 'joghurt-frucht', name: 'Fruchtjoghurt', emoji: '🥛', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'skyr', name: 'Skyr', emoji: '🥛', defaultQty: 450, defaultUnit: 'g' },
      { id: 'sahne', name: 'Sahne', emoji: '🥛', defaultQty: 200, defaultUnit: 'ml' },
      { id: 'schlagsahne', name: 'Schlagsahne', emoji: '🥛', defaultQty: 250, defaultUnit: 'ml' },
      { id: 'quark', name: 'Quark', emoji: '🥛', defaultQty: 500, defaultUnit: 'g' },
      { id: 'magerquark', name: 'Magerquark', emoji: '🥛', defaultQty: 500, defaultUnit: 'g' },
      { id: 'frischkaese', name: 'Frischkäse', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'frischkaese-kraeuter', name: 'Kräuterfrischkäse', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'eier', name: 'Eier', emoji: '🥚', defaultQty: 10, defaultUnit: 'Stück' },
      { id: 'eier-bio', name: 'Bio-Eier', emoji: '🥚', defaultQty: 6, defaultUnit: 'Stück' },
      { id: 'schmand', name: 'Schmand', emoji: '🥛', defaultQty: 200, defaultUnit: 'g' },
      { id: 'creme-fraiche', name: 'Crème fraîche', emoji: '🥛', defaultQty: 200, defaultUnit: 'g' },
      { id: 'saure-sahne', name: 'Saure Sahne', emoji: '🥛', defaultQty: 200, defaultUnit: 'g' },
      { id: 'mozzarella', name: 'Mozzarella', emoji: '🧀', defaultQty: 125, defaultUnit: 'g' },
      { id: 'burrata', name: 'Burrata', emoji: '🧀', defaultQty: 125, defaultUnit: 'g' },
      { id: 'parmesan', name: 'Parmesan', emoji: '🧀', defaultQty: 100, defaultUnit: 'g' },
      { id: 'ricotta', name: 'Ricotta', emoji: '🧀', defaultQty: 250, defaultUnit: 'g' },
      { id: 'mascarpone', name: 'Mascarpone', emoji: '🧀', defaultQty: 250, defaultUnit: 'g' },
      { id: 'huettenkaese', name: 'Hüttenkäse', emoji: '🧀', defaultQty: 200, defaultUnit: 'g' },
      { id: 'pudding', name: 'Pudding', emoji: '🥛', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'milchreis', name: 'Milchreis', emoji: '🥛', defaultQty: 200, defaultUnit: 'g' },
    ]
  },
  'fleisch-fisch': {
    id: 'fleisch-fisch',
    label: 'Fleisch & Fisch',
    emoji: '🥩',
    products: [
      // Geflügel
      { id: 'haehnchen', name: 'Hähnchenbrust', emoji: '🍗', defaultQty: 500, defaultUnit: 'g' },
      { id: 'haehnchenschenkel', name: 'Hähnchenschenkel', emoji: '🍗', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'haehnchenfluegel', name: 'Hähnchenflügel', emoji: '🍗', defaultQty: 500, defaultUnit: 'g' },
      { id: 'haenchenfleisch', name: 'Hähnchenfleisch', emoji: '🍗', defaultQty: 500, defaultUnit: 'g' },
      { id: 'putenbrust', name: 'Putenbrust', emoji: '🍗', defaultQty: 400, defaultUnit: 'g' },
      { id: 'putenschnitzel', name: 'Putenschnitzel', emoji: '🍗', defaultQty: 400, defaultUnit: 'g' },
      { id: 'ente', name: 'Entenbrust', emoji: '🦆', defaultQty: 400, defaultUnit: 'g' },
      // Schwein
      { id: 'schweinefleisch', name: 'Schweinefleisch', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'schweineschnitzel', name: 'Schweineschnitzel', emoji: '🥩', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'schweinefilet', name: 'Schweinefilet', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'schweinebauch', name: 'Schweinebauch', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'kotelett', name: 'Kotelett', emoji: '🥩', defaultQty: 4, defaultUnit: 'Stück' },
      // Rind
      { id: 'rindfleisch', name: 'Rindfleisch', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'rindersteak', name: 'Rindersteak', emoji: '🥩', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'rinderfilet', name: 'Rinderfilet', emoji: '🥩', defaultQty: 400, defaultUnit: 'g' },
      { id: 'roastbeef', name: 'Roastbeef', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'gulasch', name: 'Gulasch', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      // Hack
      { id: 'hackfleisch', name: 'Hackfleisch gemischt', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'hackfleisch-rind', name: 'Rinderhack', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'hackfleisch-schwein', name: 'Schweinehack', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      // Lamm
      { id: 'lammfleisch', name: 'Lammfleisch', emoji: '🥩', defaultQty: 500, defaultUnit: 'g' },
      { id: 'lammkoteletts', name: 'Lammkoteletts', emoji: '🥩', defaultQty: 4, defaultUnit: 'Stück' },
      // Wurst & Aufschnitt
      { id: 'bratwurst', name: 'Bratwurst', emoji: '🌭', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'wiener', name: 'Wiener Würstchen', emoji: '🌭', defaultQty: 6, defaultUnit: 'Stück' },
      { id: 'bockwurst', name: 'Bockwurst', emoji: '🌭', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'schinken', name: 'Schinken', emoji: '🥓', defaultQty: 200, defaultUnit: 'g' },
      { id: 'kochschinken', name: 'Kochschinken', emoji: '🥓', defaultQty: 200, defaultUnit: 'g' },
      { id: 'rohschinken', name: 'Rohschinken', emoji: '🥓', defaultQty: 100, defaultUnit: 'g' },
      { id: 'speck', name: 'Speck', emoji: '🥓', defaultQty: 150, defaultUnit: 'g' },
      { id: 'bacon', name: 'Bacon', emoji: '🥓', defaultQty: 150, defaultUnit: 'g' },
      { id: 'salami', name: 'Salami', emoji: '🍖', defaultQty: 100, defaultUnit: 'g' },
      { id: 'mortadella', name: 'Mortadella', emoji: '🍖', defaultQty: 150, defaultUnit: 'g' },
      { id: 'leberwurst', name: 'Leberwurst', emoji: '🍖', defaultQty: 150, defaultUnit: 'g' },
      { id: 'fleischkaese', name: 'Fleischkäse', emoji: '🍖', defaultQty: 200, defaultUnit: 'g' },
      { id: 'putenbrust-aufschnitt', name: 'Putenbrustaufschnitt', emoji: '🍗', defaultQty: 150, defaultUnit: 'g' },
      // Fisch
      { id: 'lachs', name: 'Lachs', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'lachsfilet', name: 'Lachsfilet', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'raeucherlachs', name: 'Räucherlachs', emoji: '🐟', defaultQty: 100, defaultUnit: 'g' },
      { id: 'forelle', name: 'Forelle', emoji: '🐟', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'kabeljau', name: 'Kabeljau', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'seelachs', name: 'Seelachs', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'pangasius', name: 'Pangasius', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'thunfisch', name: 'Thunfisch (Dose)', emoji: '🐟', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'thunfisch-frisch', name: 'Thunfisch (frisch)', emoji: '🐟', defaultQty: 300, defaultUnit: 'g' },
      { id: 'makrele', name: 'Makrele', emoji: '🐟', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'sardinen', name: 'Sardinen', emoji: '🐟', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'garnelen', name: 'Garnelen', emoji: '🦐', defaultQty: 200, defaultUnit: 'g' },
      { id: 'shrimps', name: 'Shrimps', emoji: '🦐', defaultQty: 200, defaultUnit: 'g' },
      { id: 'muscheln', name: 'Muscheln', emoji: '🦪', defaultQty: 500, defaultUnit: 'g' },
      { id: 'tintenfisch', name: 'Tintenfisch', emoji: '🦑', defaultQty: 300, defaultUnit: 'g' },
      { id: 'hering', name: 'Hering', emoji: '🐟', defaultQty: 200, defaultUnit: 'g' },
      { id: 'matjes', name: 'Matjes', emoji: '🐟', defaultQty: 200, defaultUnit: 'g' },
    ]
  },
  'brot-backwaren': {
    id: 'brot-backwaren',
    label: 'Brot & Backwaren',
    emoji: '🍞',
    products: [
      // Brot
      { id: 'brot', name: 'Brot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'vollkornbrot', name: 'Vollkornbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mischbrot', name: 'Mischbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'weissbrot', name: 'Weißbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'roggenbrot', name: 'Roggenbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'dinkelbrot', name: 'Dinkelbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'pumpernickel', name: 'Pumpernickel', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'knäckebrot', name: 'Knäckebrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'toast', name: 'Toast', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'toast-vollkorn', name: 'Vollkorntoast', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'zwieback', name: 'Zwieback', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      // Brötchen
      { id: 'broetchen', name: 'Brötchen', emoji: '🥖', defaultQty: 6, defaultUnit: 'Stück' },
      { id: 'broetchen-vollkorn', name: 'Vollkornbrötchen', emoji: '🥖', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'laugenbrezel', name: 'Laugenbrezel', emoji: '🥨', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'laugenbroetchen', name: 'Laugenbrötchen', emoji: '🥨', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'baguette', name: 'Baguette', emoji: '🥖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ciabatta', name: 'Ciabatta', emoji: '🥖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fladenbrot', name: 'Fladenbrot', emoji: '🫓', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'naan', name: 'Naan-Brot', emoji: '🫓', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'pitabrot', name: 'Pitabrot', emoji: '🫓', defaultQty: 6, defaultUnit: 'Stück' },
      // Süßes
      { id: 'croissant', name: 'Croissants', emoji: '🥐', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'berliner', name: 'Berliner', emoji: '🍩', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'donut', name: 'Donuts', emoji: '🍩', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'muffin', name: 'Muffins', emoji: '🧁', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'kuchen', name: 'Kuchen', emoji: '🍰', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'hefezopf', name: 'Hefezopf', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rosinenbrot', name: 'Rosinenbrot', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      // Teige & Fertigprodukte
      { id: 'tortilla', name: 'Tortilla-Wraps', emoji: '🫓', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'pizzateig', name: 'Pizzateig', emoji: '🍕', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'blaetterteig', name: 'Blätterteig', emoji: '🥐', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'hefeteig', name: 'Hefeteig', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'strudelteig', name: 'Strudelteig', emoji: '🥐', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'taco-schalen', name: 'Taco Schalen', emoji: '🌮', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },
  'getraenke': {
    id: 'getraenke',
    label: 'Getränke',
    emoji: '🥤',
    products: [
      // Wasser
      { id: 'wasser', name: 'Mineralwasser', emoji: '💧', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'wasser-still', name: 'Stilles Wasser', emoji: '💧', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'wasser-medium', name: 'Medium Wasser', emoji: '💧', defaultQty: 6, defaultUnit: 'Flaschen' },
      // Säfte
      { id: 'apfelsaft', name: 'Apfelsaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'orangensaft', name: 'Orangensaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'multivitaminsaft', name: 'Multivitaminsaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'traubensaft', name: 'Traubensaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'ananassaft', name: 'Ananassaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'grapefruitsaft', name: 'Grapefruitsaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'tomatensaft', name: 'Tomatensaft', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      { id: 'apfelschorle', name: 'Apfelschorle', emoji: '🧃', defaultQty: 1, defaultUnit: 'L' },
      // Limonaden
      { id: 'cola', name: 'Cola', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'cola-zero', name: 'Cola Zero', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'fanta', name: 'Fanta', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'sprite', name: 'Sprite', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'mezzo-mix', name: 'Mezzo Mix', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'spezi', name: 'Spezi', emoji: '🥤', defaultQty: 1.5, defaultUnit: 'L' },
      { id: 'limonade', name: 'Limonade', emoji: '🥤', defaultQty: 1, defaultUnit: 'L' },
      { id: 'eistee', name: 'Eistee', emoji: '🧃', defaultQty: 1.5, defaultUnit: 'L' },
      // Energy Drinks
      { id: 'energy-drink', name: 'Energy Drink', emoji: '🥫', defaultQty: 4, defaultUnit: 'Dosen' },
      { id: 'red-bull', name: 'Red Bull', emoji: '🥫', defaultQty: 4, defaultUnit: 'Dosen' },
      // Alkohol
      { id: 'bier', name: 'Bier', emoji: '🍺', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'bier-alkoholfrei', name: 'Alkoholfreies Bier', emoji: '🍺', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'radler', name: 'Radler', emoji: '🍺', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'weizen', name: 'Weizenbier', emoji: '🍺', defaultQty: 6, defaultUnit: 'Flaschen' },
      { id: 'wein-rot', name: 'Rotwein', emoji: '🍷', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'wein-weiss', name: 'Weißwein', emoji: '🥂', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'wein-rose', name: 'Roséwein', emoji: '🍷', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sekt', name: 'Sekt', emoji: '🥂', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'prosecco', name: 'Prosecco', emoji: '🥂', defaultQty: 1, defaultUnit: 'Flasche' },
      // Heißgetränke
      { id: 'kaffee', name: 'Kaffee', emoji: '☕', defaultQty: 500, defaultUnit: 'g' },
      { id: 'kaffee-bohnen', name: 'Kaffeebohnen', emoji: '☕', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'espresso', name: 'Espresso', emoji: '☕', defaultQty: 250, defaultUnit: 'g' },
      { id: 'kaffeekapseln', name: 'Kaffeekapseln', emoji: '☕', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'instantkaffee', name: 'Instantkaffee', emoji: '☕', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'tee', name: 'Tee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-schwarz', name: 'Schwarztee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-gruen', name: 'Grüner Tee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-frucht', name: 'Früchtetee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-kraeuter', name: 'Kräutertee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-pfefferminz', name: 'Pfefferminztee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tee-kamille', name: 'Kamillentee', emoji: '🍵', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kakao', name: 'Kakao', emoji: '🍫', defaultQty: 250, defaultUnit: 'g' },
    ]
  },
  'tiefkuehl': {
    id: 'tiefkuehl',
    label: 'Tiefkühl',
    emoji: '🧊',
    products: [
      // Fertiggerichte
      { id: 'tiefkuehl-pizza', name: 'TK-Pizza', emoji: '🍕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tiefkuehl-lasagne', name: 'TK-Lasagne', emoji: '🍝', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tiefkuehl-schnitzel', name: 'TK-Schnitzel', emoji: '🍖', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tiefkuehl-chicken-nuggets', name: 'Chicken Nuggets', emoji: '🍗', defaultQty: 1, defaultUnit: 'Packung' },
      // Gemüse
      { id: 'tiefkuehl-gemuese', name: 'TK-Gemüse', emoji: '🥦', defaultQty: 450, defaultUnit: 'g' },
      { id: 'tiefkuehl-erbsen', name: 'TK-Erbsen', emoji: '🟢', defaultQty: 450, defaultUnit: 'g' },
      { id: 'tiefkuehl-brokkoli', name: 'TK-Brokkoli', emoji: '🥦', defaultQty: 450, defaultUnit: 'g' },
      { id: 'tiefkuehl-spinat', name: 'TK-Spinat', emoji: '🥬', defaultQty: 450, defaultUnit: 'g' },
      { id: 'tiefkuehl-bohnen', name: 'TK-Bohnen', emoji: '🫛', defaultQty: 450, defaultUnit: 'g' },
      { id: 'tiefkuehl-mais', name: 'TK-Mais', emoji: '🌽', defaultQty: 450, defaultUnit: 'g' },
      // Obst
      { id: 'tiefkuehl-beeren', name: 'TK-Beeren', emoji: '🫐', defaultQty: 300, defaultUnit: 'g' },
      { id: 'tiefkuehl-erdbeeren', name: 'TK-Erdbeeren', emoji: '🍓', defaultQty: 300, defaultUnit: 'g' },
      { id: 'tiefkuehl-himbeeren', name: 'TK-Himbeeren', emoji: '🍇', defaultQty: 300, defaultUnit: 'g' },
      // Kartoffelprodukte
      { id: 'tiefkuehl-pommes', name: 'Pommes', emoji: '🍟', defaultQty: 750, defaultUnit: 'g' },
      { id: 'tiefkuehl-wedges', name: 'Potato Wedges', emoji: '🍟', defaultQty: 750, defaultUnit: 'g' },
      { id: 'tiefkuehl-krokett', name: 'Kroketten', emoji: '🍟', defaultQty: 500, defaultUnit: 'g' },
      { id: 'tiefkuehl-roesti', name: 'Rösti', emoji: '🥔', defaultQty: 600, defaultUnit: 'g' },
      { id: 'tiefkuehl-kartoffelpuffer', name: 'Kartoffelpuffer', emoji: '🥔', defaultQty: 600, defaultUnit: 'g' },
      // Fisch
      { id: 'fischstaebchen', name: 'Fischstäbchen', emoji: '🐟', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tiefkuehl-lachs', name: 'TK-Lachs', emoji: '🐟', defaultQty: 400, defaultUnit: 'g' },
      { id: 'tiefkuehl-garnelen', name: 'TK-Garnelen', emoji: '🦐', defaultQty: 200, defaultUnit: 'g' },
      // Eis
      { id: 'eis', name: 'Eis', emoji: '🍨', defaultQty: 500, defaultUnit: 'ml' },
      { id: 'eis-vanille', name: 'Vanilleeis', emoji: '🍨', defaultQty: 500, defaultUnit: 'ml' },
      { id: 'eis-schoko', name: 'Schokoeis', emoji: '🍫', defaultQty: 500, defaultUnit: 'ml' },
      { id: 'eis-am-stiel', name: 'Eis am Stiel', emoji: '🍦', defaultQty: 1, defaultUnit: 'Packung' },
      // Backwaren
      { id: 'tiefkuehl-broetchen', name: 'TK-Brötchen', emoji: '🥖', defaultQty: 6, defaultUnit: 'Stück' },
      { id: 'tiefkuehl-baguette', name: 'TK-Baguette', emoji: '🥖', defaultQty: 2, defaultUnit: 'Stück' },
    ]
  },
  'haushalt': {
    id: 'haushalt',
    label: 'Haushalt',
    emoji: '🧴',
    products: [
      // Papierprodukte
      { id: 'toilettenpapier', name: 'Toilettenpapier', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kuechenpapier', name: 'Küchenpapier', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'taschentuecher', name: 'Taschentücher', emoji: '🤧', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'servietten', name: 'Servietten', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      // Reinigungsmittel
      { id: 'spuelmittel', name: 'Spülmittel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'spuelmaschinentabs', name: 'Spülmaschinentabs', emoji: '🧴', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'klarspueler', name: 'Klarspüler', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'spuelmaschinensalz', name: 'Spülmaschinensalz', emoji: '🧂', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'waschmittel', name: 'Waschmittel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'waschmittel-fluessig', name: 'Flüssigwaschmittel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'weichspueler', name: 'Weichspüler', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'fleckenentferner', name: 'Fleckenentferner', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'allzweckreiniger', name: 'Allzweckreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'glasreiniger', name: 'Glasreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'badreiniger', name: 'Badreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'wc-reiniger', name: 'WC-Reiniger', emoji: '🚽', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'bodenreiniger', name: 'Bodenreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'entkalker', name: 'Entkalker', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'scheuermilch', name: 'Scheuermilch', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      // Müll & Aufbewahrung
      { id: 'muellbeutel', name: 'Müllbeutel', emoji: '🗑️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'muellbeutel-bio', name: 'Biomüllbeutel', emoji: '🗑️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'gefrierbeutel', name: 'Gefrierbeutel', emoji: '🧊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'alufolie', name: 'Alufolie', emoji: '📄', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'frischhaltefolie', name: 'Frischhaltefolie', emoji: '📄', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'backpapier', name: 'Backpapier', emoji: '📄', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'butterbrotpapier', name: 'Butterbrotpapier', emoji: '📄', defaultQty: 1, defaultUnit: 'Packung' },
      // Reinigungsutensilien
      { id: 'schwamm', name: 'Schwämme', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'stahlwolle', name: 'Stahlwolle', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'spuelbuerste', name: 'Spülbürste', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'putzlappen', name: 'Putzlappen', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'mikrofasertuecher', name: 'Mikrofasertücher', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'staubtuecher', name: 'Staubtücher', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'wischmop', name: 'Wischmopp', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'besen', name: 'Besen', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gummihandschuhe', name: 'Gummihandschuhe', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      // Sonstiges
      { id: 'batterien-aa', name: 'Batterien AA', emoji: '🔋', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'batterien-aaa', name: 'Batterien AAA', emoji: '🔋', defaultQty: 4, defaultUnit: 'Stück' },
      { id: 'gluehbirne', name: 'Glühbirne', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kerzen', name: 'Kerzen', emoji: '🕯️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'streichhoelzer', name: 'Streichhölzer', emoji: '🔥', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'feuerzeug', name: 'Feuerzeug', emoji: '🔥', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },
  'koerperpflege': {
    id: 'koerperpflege',
    label: 'Körperpflege',
    emoji: '🧼',
    products: [
      // Haarpflege
      { id: 'shampoo', name: 'Shampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'shampoo-schuppen', name: 'Anti-Schuppen Shampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'spuelung', name: 'Spülung', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'haarkur', name: 'Haarkur', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'haarspray', name: 'Haarspray', emoji: '🧴', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'haargel', name: 'Haargel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'haarwachs', name: 'Haarwachs', emoji: '🧴', defaultQty: 1, defaultUnit: 'Dose' },
      // Körper
      { id: 'duschgel', name: 'Duschgel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'seife', name: 'Seife', emoji: '🧼', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fluessigseife', name: 'Flüssigseife', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'bodylotion', name: 'Bodylotion', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'handcreme', name: 'Handcreme', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'deo', name: 'Deo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'deo-spray', name: 'Deo-Spray', emoji: '🧴', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'deo-roll-on', name: 'Deo Roll-On', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      // Gesichtspflege
      { id: 'gesichtscreme', name: 'Gesichtscreme', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'gesichtsreinigung', name: 'Gesichtsreinigung', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'lippenpflege', name: 'Lippenpflege', emoji: '💄', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sonnencreme', name: 'Sonnencreme', emoji: '☀️', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'after-sun', name: 'After Sun', emoji: '☀️', defaultQty: 1, defaultUnit: 'Flasche' },
      // Mundhygiene
      { id: 'zahnpasta', name: 'Zahnpasta', emoji: '🪥', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'zahnbuerste', name: 'Zahnbürste', emoji: '🪥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zahnseide', name: 'Zahnseide', emoji: '🦷', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'mundspuelung', name: 'Mundspülung', emoji: '🦷', defaultQty: 1, defaultUnit: 'Flasche' },
      // Rasur
      { id: 'rasierer', name: 'Rasierer', emoji: '🪒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rasierklingen', name: 'Rasierklingen', emoji: '🪒', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'rasierschaum', name: 'Rasierschaum', emoji: '🪒', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'rasiergel', name: 'Rasiergel', emoji: '🪒', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'aftershave', name: 'Aftershave', emoji: '🪒', defaultQty: 1, defaultUnit: 'Flasche' },
      // Damenhygiene
      { id: 'tampons', name: 'Tampons', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'binden', name: 'Binden', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'slipeinlagen', name: 'Slipeinlagen', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
      // Sonstiges
      { id: 'wattepads', name: 'Wattepads', emoji: '⚪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'wattestäbchen', name: 'Wattestäbchen', emoji: '⚪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'nagelpflege', name: 'Nagelpflegeset', emoji: '💅', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'nagellackentferner', name: 'Nagellackentferner', emoji: '💅', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'parfuem', name: 'Parfüm', emoji: '🌸', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'deo-stick', name: 'Deo-Stick', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },
  'grundnahrung': {
    id: 'grundnahrung',
    label: 'Grundnahrung',
    emoji: '🍚',
    products: [
      // Nudeln & Reis
      { id: 'nudeln', name: 'Nudeln', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'spaghetti', name: 'Spaghetti', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'penne', name: 'Penne', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'fusilli', name: 'Fusilli', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'tagliatelle', name: 'Tagliatelle', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'lasagneplatten', name: 'Lasagneplatten', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'tortellini', name: 'Tortellini', emoji: '🍝', defaultQty: 250, defaultUnit: 'g' },
      { id: 'gnocchi', name: 'Gnocchi', emoji: '🍝', defaultQty: 500, defaultUnit: 'g' },
      { id: 'reis', name: 'Reis', emoji: '🍚', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'basmati-reis', name: 'Basmati Reis', emoji: '🍚', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'jasmin-reis', name: 'Jasmin Reis', emoji: '🍚', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'risotto-reis', name: 'Risotto Reis', emoji: '🍚', defaultQty: 500, defaultUnit: 'g' },
      { id: 'milchreis-reis', name: 'Milchreis', emoji: '🍚', defaultQty: 500, defaultUnit: 'g' },
      { id: 'couscous', name: 'Couscous', emoji: '🍚', defaultQty: 500, defaultUnit: 'g' },
      { id: 'bulgur', name: 'Bulgur', emoji: '🌾', defaultQty: 500, defaultUnit: 'g' },
      { id: 'quinoa', name: 'Quinoa', emoji: '🌾', defaultQty: 400, defaultUnit: 'g' },
      // Mehl & Backen
      { id: 'mehl', name: 'Mehl', emoji: '🌾', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'mehl-vollkorn', name: 'Vollkornmehl', emoji: '🌾', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'mehl-dinkel', name: 'Dinkelmehl', emoji: '🌾', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'zucker', name: 'Zucker', emoji: '🍬', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'puderzucker', name: 'Puderzucker', emoji: '🍬', defaultQty: 250, defaultUnit: 'g' },
      { id: 'brauner-zucker', name: 'Brauner Zucker', emoji: '🍬', defaultQty: 500, defaultUnit: 'g' },
      { id: 'vanillezucker', name: 'Vanillezucker', emoji: '🍬', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'backpulver', name: 'Backpulver', emoji: '🧁', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'hefe', name: 'Hefe', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'trockenhefe', name: 'Trockenhefe', emoji: '🍞', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'natron', name: 'Natron', emoji: '🧁', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'speisestaerke', name: 'Speisestärke', emoji: '🌾', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'paniermehl', name: 'Paniermehl', emoji: '🍞', defaultQty: 500, defaultUnit: 'g' },
      // Öle & Essig
      { id: 'oel', name: 'Sonnenblumenöl', emoji: '🫒', defaultQty: 1, defaultUnit: 'L' },
      { id: 'rapsoel', name: 'Rapsöl', emoji: '🫒', defaultQty: 1, defaultUnit: 'L' },
      { id: 'olivenoel', name: 'Olivenöl', emoji: '🫒', defaultQty: 500, defaultUnit: 'ml' },
      { id: 'kokosoel', name: 'Kokosöl', emoji: '🥥', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'sesamoel', name: 'Sesamöl', emoji: '🫒', defaultQty: 250, defaultUnit: 'ml' },
      { id: 'essig', name: 'Essig', emoji: '🍶', defaultQty: 500, defaultUnit: 'ml' },
      { id: 'balsamico', name: 'Balsamico', emoji: '🍶', defaultQty: 250, defaultUnit: 'ml' },
      { id: 'apfelessig', name: 'Apfelessig', emoji: '🍶', defaultQty: 500, defaultUnit: 'ml' },
      // Würzen
      { id: 'salz', name: 'Salz', emoji: '🧂', defaultQty: 500, defaultUnit: 'g' },
      { id: 'pfeffer', name: 'Pfeffer', emoji: '🧂', defaultQty: 1, defaultUnit: 'Glas' },
      // Konserven & Saucen
      { id: 'tomatenmark', name: 'Tomatenmark', emoji: '🍅', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'passierte-tomaten', name: 'Passierte Tomaten', emoji: '🍅', defaultQty: 500, defaultUnit: 'g' },
      { id: 'gehackte-tomaten', name: 'Gehackte Tomaten', emoji: '🍅', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'mais-dose', name: 'Mais (Dose)', emoji: '🌽', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'kidneybohnen', name: 'Kidneybohnen', emoji: '🫘', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'kichererbsen', name: 'Kichererbsen', emoji: '🫘', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'weisse-bohnen', name: 'Weiße Bohnen', emoji: '🫘', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'linsen', name: 'Linsen', emoji: '🫘', defaultQty: 500, defaultUnit: 'g' },
      { id: 'linsen-rot', name: 'Rote Linsen', emoji: '🫘', defaultQty: 500, defaultUnit: 'g' },
      // Aufstriche
      { id: 'honig', name: 'Honig', emoji: '🍯', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'marmelade', name: 'Marmelade', emoji: '🍓', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'marmelade-erdbeer', name: 'Erdbeermarmelade', emoji: '🍓', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'nutella', name: 'Nutella', emoji: '🍫', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'erdnussbutter', name: 'Erdnussbutter', emoji: '🥜', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'ahornsirup', name: 'Ahornsirup', emoji: '🍁', defaultQty: 1, defaultUnit: 'Flasche' },
      // Müsli & Frühstück
      { id: 'haferflocken', name: 'Haferflocken', emoji: '🥣', defaultQty: 500, defaultUnit: 'g' },
      { id: 'muesli', name: 'Müsli', emoji: '🥣', defaultQty: 500, defaultUnit: 'g' },
      { id: 'cornflakes', name: 'Cornflakes', emoji: '🥣', defaultQty: 375, defaultUnit: 'g' },
      { id: 'crunchy-muesli', name: 'Crunchy Müsli', emoji: '🥣', defaultQty: 500, defaultUnit: 'g' },
    ]
  },
  'gewuerze-saucen': {
    id: 'gewuerze-saucen',
    label: 'Gewürze & Saucen',
    emoji: '🌶️',
    products: [
      // Gewürze
      { id: 'paprikapulver', name: 'Paprikapulver', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'paprika-edelsüß', name: 'Paprika edelsüß', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'curry', name: 'Curry', emoji: '🍛', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'kurkuma', name: 'Kurkuma', emoji: '🟡', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'kreuzkuemmel', name: 'Kreuzkümmel', emoji: '🌰', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'koriander-gemahlen', name: 'Koriander gemahlen', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'zimt', name: 'Zimt', emoji: '🪵', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'muskat', name: 'Muskat', emoji: '🌰', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'nelken', name: 'Nelken', emoji: '🌸', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'kardamom', name: 'Kardamom', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'ingwer-gemahlen', name: 'Ingwer gemahlen', emoji: '🧄', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'chilipulver', name: 'Chilipulver', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'chiliflocken', name: 'Chiliflocken', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'cayennepfeffer', name: 'Cayennepfeffer', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'knoblauchpulver', name: 'Knoblauchpulver', emoji: '🧄', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'zwiebelpulver', name: 'Zwiebelpulver', emoji: '🧅', defaultQty: 1, defaultUnit: 'Glas' },
      // Kräuter getrocknet
      { id: 'basilikum', name: 'Basilikum (getrocknet)', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'oregano', name: 'Oregano', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'thymian-getrocknet', name: 'Thymian (getrocknet)', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'rosmarin-getrocknet', name: 'Rosmarin (getrocknet)', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'majoran', name: 'Majoran', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'lorbeerblätter', name: 'Lorbeerblätter', emoji: '🌿', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'petersilie-getrocknet', name: 'Petersilie (getrocknet)', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'italienische-kraeuter', name: 'Italienische Kräuter', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'kraeutermischung', name: 'Kräutermischung', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      // Saucen
      { id: 'ketchup', name: 'Ketchup', emoji: '🍅', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'mayo', name: 'Mayonnaise', emoji: '🥚', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'senf', name: 'Senf', emoji: '🟡', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'senf-suess', name: 'Süßer Senf', emoji: '🟡', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'sojasauce', name: 'Sojasauce', emoji: '🥢', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'worcestersauce', name: 'Worcestersauce', emoji: '🍶', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'tabasco', name: 'Tabasco', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sriracha', name: 'Sriracha', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'bbq-sauce', name: 'BBQ-Sauce', emoji: '🍖', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sweet-chili', name: 'Sweet Chili Sauce', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sambal-oelek', name: 'Sambal Oelek', emoji: '🌶️', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'pesto', name: 'Pesto', emoji: '🌿', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'pesto-rosso', name: 'Pesto Rosso', emoji: '🍅', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'aioli', name: 'Aioli', emoji: '🧄', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'remoulade', name: 'Remoulade', emoji: '🥚', defaultQty: 1, defaultUnit: 'Glas' },
      // Fertigprodukte
      { id: 'bruehwuerfel', name: 'Brühwürfel', emoji: '🍲', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'gemuesebruehe', name: 'Gemüsebrühe', emoji: '🍲', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'huehnerbruehe', name: 'Hühnerbrühe', emoji: '🍲', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'rinderbruehe', name: 'Rinderbrühe', emoji: '🍲', defaultQty: 1, defaultUnit: 'Glas' },
    ]
  },
  'snacks': {
    id: 'snacks',
    label: 'Snacks & Süßes',
    emoji: '🍪',
    products: [
      // Chips & Salziges
      { id: 'chips', name: 'Chips', emoji: '🥔', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'chips-paprika', name: 'Paprika Chips', emoji: '🥔', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'chips-sour-cream', name: 'Sour Cream Chips', emoji: '🥔', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'nachos', name: 'Nachos', emoji: '🌮', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'salzstangen', name: 'Salzstangen', emoji: '🥨', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'erdnussflips', name: 'Erdnussflips', emoji: '🥜', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'cracker', name: 'Cracker', emoji: '🍘', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'popcorn', name: 'Popcorn', emoji: '🍿', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'popcorn-suess', name: 'Süßes Popcorn', emoji: '🍿', defaultQty: 1, defaultUnit: 'Tüte' },
      // Nüsse & Trockenfrüchte
      { id: 'nuesse', name: 'Nüsse (gemischt)', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'erdnuesse', name: 'Erdnüsse', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'cashews', name: 'Cashews', emoji: '🥜', defaultQty: 150, defaultUnit: 'g' },
      { id: 'mandeln', name: 'Mandeln', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'walnuesse', name: 'Walnüsse', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'haselnuesse', name: 'Haselnüsse', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'studentenfutter', name: 'Studentenfutter', emoji: '🥜', defaultQty: 200, defaultUnit: 'g' },
      { id: 'rosinen', name: 'Rosinen', emoji: '🍇', defaultQty: 200, defaultUnit: 'g' },
      // Schokolade
      { id: 'schokolade', name: 'Schokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Tafel' },
      { id: 'schokolade-vollmilch', name: 'Vollmilchschokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Tafel' },
      { id: 'schokolade-zartbitter', name: 'Zartbitterschokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Tafel' },
      { id: 'schokolade-weiss', name: 'Weiße Schokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Tafel' },
      { id: 'schokolade-nuss', name: 'Nussschokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Tafel' },
      { id: 'schokoriegel', name: 'Schokoriegel', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'pralinen', name: 'Pralinen', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      // Süßigkeiten
      { id: 'gummibaerchen', name: 'Gummibärchen', emoji: '🍬', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'weingummi', name: 'Weingummi', emoji: '🍬', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'lakritz', name: 'Lakritz', emoji: '🍬', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'bonbons', name: 'Bonbons', emoji: '🍬', defaultQty: 1, defaultUnit: 'Tüte' },
      { id: 'lollies', name: 'Lollies', emoji: '🍭', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kaugummi', name: 'Kaugummi', emoji: '🍬', defaultQty: 1, defaultUnit: 'Packung' },
      // Kekse & Gebäck
      { id: 'kekse', name: 'Kekse', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kekse-schoko', name: 'Schokokekse', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'oreo', name: 'Oreo', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'waffeln', name: 'Waffeln', emoji: '🧇', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'zwieback-kinder', name: 'Kinderzwieback', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'muesli-riegel', name: 'Müsliriegel', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'proteinriegel', name: 'Proteinriegel', emoji: '💪', defaultQty: 1, defaultUnit: 'Stück' },
      // Eis am Stiel (wenn nicht gefroren)
      { id: 'wassereis', name: 'Wassereis', emoji: '🍦', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },
  'baby-kinder': {
    id: 'baby-kinder',
    label: 'Baby & Kinder',
    emoji: '👶',
    products: [
      // Babynahrung
      { id: 'babymilch', name: 'Babymilch', emoji: '🍼', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'folgemilch', name: 'Folgemilch', emoji: '🍼', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'babybrei', name: 'Babybrei', emoji: '🥣', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'babybrei-obst', name: 'Babybrei Obst', emoji: '🍎', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'babybrei-gemuese', name: 'Babybrei Gemüse', emoji: '🥕', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'babybrei-fleisch', name: 'Babybrei mit Fleisch', emoji: '🍖', defaultQty: 1, defaultUnit: 'Glas' },
      { id: 'babykekse', name: 'Babykekse', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'quetschie', name: 'Quetschies', emoji: '🍎', defaultQty: 4, defaultUnit: 'Stück' },
      // Windeln & Pflege
      { id: 'windeln', name: 'Windeln', emoji: '👶', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'feuchttuecher', name: 'Feuchttücher', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'babycreme', name: 'Babycreme', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'wundschutzcreme', name: 'Wundschutzcreme', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'babyshampoo', name: 'Babyshampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'babybad', name: 'Babybad', emoji: '🛁', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'babylotion', name: 'Babylotion', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'babyoel', name: 'Babyöl', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      // Kinderprodukte
      { id: 'kinderzahnpasta', name: 'Kinderzahnpasta', emoji: '🪥', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'kinderzahnbuerste', name: 'Kinderzahnbürste', emoji: '🪥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kindershampoo', name: 'Kindershampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'kinderduschgel', name: 'Kinderduschgel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sonnencreme-kinder', name: 'Kindersonnencreme', emoji: '☀️', defaultQty: 1, defaultUnit: 'Tube' },
      // Kindersnacks
      { id: 'fruchtzwerge', name: 'Fruchtzwerge', emoji: '🥛', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kinderschokolade', name: 'Kinderschokolade', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kinderriegel', name: 'Kinderriegel', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kindercerealien', name: 'Kindercerealien', emoji: '🥣', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kinderkekse', name: 'Kinderkekse', emoji: '🍪', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },
  'drogerie-gesundheit': {
    id: 'drogerie-gesundheit',
    label: 'Drogerie & Gesundheit',
    emoji: '💊',
    products: [
      // Medikamente (rezeptfrei)
      { id: 'schmerzmittel', name: 'Schmerzmittel', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'ibuprofen', name: 'Ibuprofen', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'paracetamol', name: 'Paracetamol', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'aspirin', name: 'Aspirin', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'hustensaft', name: 'Hustensaft', emoji: '🍯', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'halstabletten', name: 'Halstabletten', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'nasenspray', name: 'Nasenspray', emoji: '👃', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'augentropfen', name: 'Augentropfen', emoji: '👁️', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'magentabletten', name: 'Magentabletten', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'durchfallmittel', name: 'Durchfallmittel', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'abfuehrmittel', name: 'Abführmittel', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      // Vitamine & Nahrungsergänzung
      { id: 'vitamin-c', name: 'Vitamin C', emoji: '🍊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'vitamin-d', name: 'Vitamin D', emoji: '☀️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'multivitamin', name: 'Multivitamin', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'magnesium', name: 'Magnesium', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'zink', name: 'Zink', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'eisen', name: 'Eisen', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'omega-3', name: 'Omega-3', emoji: '🐟', defaultQty: 1, defaultUnit: 'Packung' },
      // Erste Hilfe
      { id: 'pflaster', name: 'Pflaster', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'verband', name: 'Verband', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'desinfektionsmittel', name: 'Desinfektionsmittel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'wundsalbe', name: 'Wundsalbe', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'kuehltasche', name: 'Kühlpack', emoji: '🧊', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fieberthermometer', name: 'Fieberthermometer', emoji: '🌡️', defaultQty: 1, defaultUnit: 'Stück' },
      // Sonstiges
      { id: 'kondome', name: 'Kondome', emoji: '🛡️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'handdesinfektion', name: 'Handdesinfektion', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'mundschutz', name: 'Mundschutz', emoji: '😷', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'blasenpflaster', name: 'Blasenpflaster', emoji: '🩹', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },
  'tiernahrung': {
    id: 'tiernahrung',
    label: 'Tiernahrung',
    emoji: '🐾',
    products: [
      // Hundefutter
      { id: 'hundefutter-trocken', name: 'Hundefutter trocken', emoji: '🐕', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'hundefutter-nass', name: 'Hundefutter nass', emoji: '🐕', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'hundesnacks', name: 'Hundesnacks', emoji: '🦴', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kauknochen', name: 'Kauknochen', emoji: '🦴', defaultQty: 1, defaultUnit: 'Packung' },
      // Katzenfutter
      { id: 'katzenfutter-trocken', name: 'Katzenfutter trocken', emoji: '🐈', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'katzenfutter-nass', name: 'Katzenfutter nass', emoji: '🐈', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'katzensnacks', name: 'Katzensnacks', emoji: '🐱', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'katzenstreu', name: 'Katzenstreu', emoji: '🐱', defaultQty: 1, defaultUnit: 'Packung' },
      // Kleintiere
      { id: 'vogelfutter', name: 'Vogelfutter', emoji: '🐦', defaultQty: 1, defaultUnit: 'kg' },
      { id: 'fischfutter', name: 'Fischfutter', emoji: '🐟', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'hamsterfutter', name: 'Hamsterfutter', emoji: '🐹', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'heu', name: 'Heu', emoji: '🌾', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },

  // ✅ v2.1: NEU - Baumarkt
  'baumarkt': {
    id: 'baumarkt',
    label: 'Baumarkt',
    emoji: '🔨',
    products: [
      // Werkzeuge
      { id: 'hammer', name: 'Hammer', emoji: '🔨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schraubenzieher', name: 'Schraubenzieher', emoji: '🪛', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schraubenzieher-set', name: 'Schraubenzieher-Set', emoji: '🪛', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'zange', name: 'Zange', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kombizange', name: 'Kombizange', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schraubenschluessel', name: 'Schraubenschlüssel', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'inbusschluessel', name: 'Inbusschlüssel-Set', emoji: '🔧', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'massband', name: 'Maßband', emoji: '📏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zollstock', name: 'Zollstock', emoji: '📏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wasserwaage', name: 'Wasserwaage', emoji: '📐', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'saege', name: 'Handsäge', emoji: '🪚', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'cuttermesser', name: 'Cuttermesser', emoji: '🔪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'bohrmaschine', name: 'Bohrmaschine', emoji: '🔩', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'akkuschrauber', name: 'Akkuschrauber', emoji: '🔩', defaultQty: 1, defaultUnit: 'Stück' },
      // Befestigungsmaterial
      { id: 'schrauben', name: 'Schrauben', emoji: '🔩', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'naegel', name: 'Nägel', emoji: '🔩', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'duebel', name: 'Dübel', emoji: '🔩', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'muttern', name: 'Muttern', emoji: '🔩', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'unterlegscheiben', name: 'Unterlegscheiben', emoji: '⚙️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kabelbinder', name: 'Kabelbinder', emoji: '🔗', defaultQty: 1, defaultUnit: 'Packung' },
      // Kleber & Dichtung
      { id: 'klebeband', name: 'Klebeband', emoji: '🎗️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'isolierband', name: 'Isolierband', emoji: '🎗️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'panzertape', name: 'Panzertape', emoji: '🎗️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'sekundenkleber', name: 'Sekundenkleber', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'holzleim', name: 'Holzleim', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'montagekleber', name: 'Montagekleber', emoji: '🧴', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'silikon', name: 'Silikon', emoji: '🧴', defaultQty: 1, defaultUnit: 'Kartusche' },
      { id: 'wd40', name: 'WD-40', emoji: '🧴', defaultQty: 1, defaultUnit: 'Dose' },
      // Farbe & Malerbedarf
      { id: 'wandfarbe-weiss', name: 'Wandfarbe weiß', emoji: '🎨', defaultQty: 1, defaultUnit: 'Eimer' },
      { id: 'lackfarbe', name: 'Lackfarbe', emoji: '🎨', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'pinsel', name: 'Pinsel', emoji: '🖌️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'farbrolle', name: 'Farbrolle', emoji: '🖌️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'malerkrepp', name: 'Malerkrepp', emoji: '🎗️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'abdeckfolie', name: 'Abdeckfolie', emoji: '📄', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'schleifpapier', name: 'Schleifpapier', emoji: '📄', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'spachtelmasse', name: 'Spachtelmasse', emoji: '🪣', defaultQty: 1, defaultUnit: 'Dose' },
      // Garten
      { id: 'blumenerde', name: 'Blumenerde', emoji: '🌱', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'duenger', name: 'Dünger', emoji: '🌿', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'rasensamen', name: 'Rasensamen', emoji: '🌱', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'gartenschlauch', name: 'Gartenschlauch', emoji: '🌊', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'giesskanne', name: 'Gießkanne', emoji: '🚿', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gartenhandschuhe', name: 'Gartenhandschuhe', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'schaufel', name: 'Schaufel', emoji: '⛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rechen', name: 'Rechen', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      // Sonstiges
      { id: 'arbeitshandschuhe', name: 'Arbeitshandschuhe', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'schutzbrille', name: 'Schutzbrille', emoji: '🥽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'taschenlampe', name: 'Taschenlampe', emoji: '🔦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'batterien-aa', name: 'Batterien AA', emoji: '🔋', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'batterien-aaa', name: 'Batterien AAA', emoji: '🔋', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },

  // ✅ v2.1: NEU - Elektrogeräte
  'elektrogeraete': {
    id: 'elektrogeraete',
    label: 'Elektrogeräte',
    emoji: '🔌',
    products: [
      // Küchengeräte
      { id: 'wasserkocher', name: 'Wasserkocher', emoji: '☕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'toaster', name: 'Toaster', emoji: '🍞', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kaffeemaschine', name: 'Kaffeemaschine', emoji: '☕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mixer', name: 'Mixer', emoji: '🥤', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'standmixer', name: 'Standmixer', emoji: '🥤', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'handruehrer', name: 'Handrührgerät', emoji: '🥄', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kuechenmaschine', name: 'Küchenmaschine', emoji: '🤖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mikrowelle', name: 'Mikrowelle', emoji: '📻', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sandwichmaker', name: 'Sandwichmaker', emoji: '🥪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'waffeleisen', name: 'Waffeleisen', emoji: '🧇', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'elektrogrill', name: 'Elektrogrill', emoji: '🍖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'heissluftfritteuse', name: 'Heißluftfritteuse', emoji: '🍟', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kuechenwaage', name: 'Küchenwaage', emoji: '⚖️', defaultQty: 1, defaultUnit: 'Stück' },
      // Haushaltsgeräte
      { id: 'staubsauger', name: 'Staubsauger', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'saugroboter', name: 'Saugroboter', emoji: '🤖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'buegeleisen', name: 'Bügeleisen', emoji: '👔', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'dampfbuegeleisen', name: 'Dampfbügeleisen', emoji: '💨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'naehmaschine', name: 'Nähmaschine', emoji: '🧵', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'heizluefter', name: 'Heizlüfter', emoji: '🌡️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ventilator', name: 'Ventilator', emoji: '🌀', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'luftreiniger', name: 'Luftreiniger', emoji: '💨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'luftbefeuchter', name: 'Luftbefeuchter', emoji: '💧', defaultQty: 1, defaultUnit: 'Stück' },
      // Körperpflege
      { id: 'haartrockner', name: 'Haartrockner', emoji: '💇', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'glaetteisen', name: 'Glätteisen', emoji: '💇', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lockenstab', name: 'Lockenstab', emoji: '💇', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'haarschneider', name: 'Haarschneider', emoji: '💈', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'elektrorasierer', name: 'Elektrorasierer', emoji: '🪒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'elektrische-zahnbuerste', name: 'Elektrische Zahnbürste', emoji: '🪥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zahnbuersten-aufsteckkoepfe', name: 'Zahnbürsten-Aufsätze', emoji: '🪥', defaultQty: 1, defaultUnit: 'Packung' },
      // Beleuchtung
      { id: 'gluehbirne-led', name: 'LED-Glühbirne', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gluehbirne-e27', name: 'Glühbirne E27', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gluehbirne-e14', name: 'Glühbirne E14', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lichterkette', name: 'Lichterkette', emoji: '✨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schreibtischlampe', name: 'Schreibtischlampe', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'stehlampe', name: 'Stehlampe', emoji: '🪔', defaultQty: 1, defaultUnit: 'Stück' },
      // Kabel & Stecker
      { id: 'verlaengerungskabel', name: 'Verlängerungskabel', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mehrfachsteckdose', name: 'Mehrfachsteckdose', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'usb-ladekabel', name: 'USB-Ladekabel', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'usb-c-ladekabel', name: 'USB-C Ladekabel', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'hdmi-kabel', name: 'HDMI-Kabel', emoji: '📺', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'usb-netzteil', name: 'USB-Netzteil', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'powerbank', name: 'Powerbank', emoji: '🔋', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ✅ v2.2: NEU - Bürobedarf
  'buerobedarf': {
    id: 'buerobedarf',
    label: 'Bürobedarf',
    emoji: '📎',
    products: [
      // Schreibwaren
      { id: 'kugelschreiber', name: 'Kugelschreiber', emoji: '🖊️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'bleistift', name: 'Bleistifte', emoji: '✏️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'textmarker', name: 'Textmarker', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'fineliner', name: 'Fineliner', emoji: '🖊️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'edding', name: 'Edding/Marker', emoji: '🖊️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'radiergummi', name: 'Radiergummi', emoji: '🧽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'anspitzer', name: 'Anspitzer', emoji: '✏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lineal', name: 'Lineal', emoji: '📏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'geodreieck', name: 'Geodreieck', emoji: '📐', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zirkel', name: 'Zirkel', emoji: '⭕', defaultQty: 1, defaultUnit: 'Stück' },
      // Papier
      { id: 'druckerpapier', name: 'Druckerpapier A4', emoji: '📄', defaultQty: 500, defaultUnit: 'Blatt' },
      { id: 'kopierpapier', name: 'Kopierpapier', emoji: '📄', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'notizblock', name: 'Notizblock', emoji: '📝', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'post-it', name: 'Post-it Haftnotizen', emoji: '📌', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'briefumschlaege', name: 'Briefumschläge', emoji: '✉️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'versandtaschen', name: 'Versandtaschen', emoji: '📨', defaultQty: 1, defaultUnit: 'Packung' },
      // Ordnung
      { id: 'ordner', name: 'Aktenordner', emoji: '📁', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schnellhefter', name: 'Schnellhefter', emoji: '📂', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'klarsichthuellen', name: 'Klarsichthüllen', emoji: '📄', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'trennblaetter', name: 'Trennblätter', emoji: '📑', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'mappen', name: 'Dokumentenmappen', emoji: '📁', defaultQty: 1, defaultUnit: 'Packung' },
      // Bürogeräte
      { id: 'locher', name: 'Locher', emoji: '🕳️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tacker', name: 'Tacker/Hefter', emoji: '📎', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tackernadeln', name: 'Tackernadeln', emoji: '📎', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'bueroklammern', name: 'Büroklammern', emoji: '📎', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'schere', name: 'Schere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'klebestift', name: 'Klebestift', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tesafilm', name: 'Tesafilm', emoji: '🎗️', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'korrekturroller', name: 'Korrekturroller', emoji: '✏️', defaultQty: 1, defaultUnit: 'Stück' },
      // Druckerzubehör
      { id: 'druckerpatrone', name: 'Druckerpatrone', emoji: '🖨️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'toner', name: 'Toner', emoji: '🖨️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'etiketten', name: 'Etiketten', emoji: '🏷️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'laminierfolien', name: 'Laminierfolien', emoji: '📄', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },

  // ✅ v2.2: NEU - Sport & Fitness
  'sport-fitness': {
    id: 'sport-fitness',
    label: 'Sport & Fitness',
    emoji: '🏋️',
    products: [
      // Ausrüstung
      { id: 'sportschuhe', name: 'Sportschuhe', emoji: '👟', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'laufschuhe', name: 'Laufschuhe', emoji: '👟', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'sporttasche', name: 'Sporttasche', emoji: '🎒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rucksack', name: 'Sportrucksack', emoji: '🎒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'trinkflasche', name: 'Trinkflasche', emoji: '🍶', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'handtuch-sport', name: 'Sporthandtuch', emoji: '🧖', defaultQty: 1, defaultUnit: 'Stück' },
      // Fitnessgeräte
      { id: 'yogamatte', name: 'Yogamatte', emoji: '🧘', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'hanteln', name: 'Hanteln', emoji: '🏋️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'fitnessband', name: 'Fitnessband/Theraband', emoji: '🔗', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'springseil', name: 'Springseil', emoji: '🪢', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gymnastikball', name: 'Gymnastikball', emoji: '⚽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schaumstoffrolle', name: 'Faszienrolle', emoji: '🧱', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'klimmzugstange', name: 'Klimmzugstange', emoji: '🏋️', defaultQty: 1, defaultUnit: 'Stück' },
      // Sportbälle
      { id: 'fussball', name: 'Fußball', emoji: '⚽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'basketball', name: 'Basketball', emoji: '🏀', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'volleyball', name: 'Volleyball', emoji: '🏐', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tennisbaelle', name: 'Tennisbälle', emoji: '🎾', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'badminton-set', name: 'Badminton-Set', emoji: '🏸', defaultQty: 1, defaultUnit: 'Set' },
      // Nahrungsergänzung
      { id: 'proteinpulver', name: 'Proteinpulver', emoji: '💪', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'eiweissriegel', name: 'Eiweißriegel', emoji: '🍫', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'magnesium', name: 'Magnesium', emoji: '💊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'kreatin', name: 'Kreatin', emoji: '💪', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'bcaa', name: 'BCAA', emoji: '💪', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'iso-drink', name: 'Iso-Drink Pulver', emoji: '🥤', defaultQty: 1, defaultUnit: 'Dose' },
      // Bekleidung
      { id: 'sporthose', name: 'Sporthose', emoji: '👖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sportshirt', name: 'Sport-Shirt', emoji: '👕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sportsocken', name: 'Sportsocken', emoji: '🧦', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'schweissband', name: 'Schweißband', emoji: '🎽', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ✅ v2.2: NEU - Auto & Motorrad
  'auto-motorrad': {
    id: 'auto-motorrad',
    label: 'Auto & Motorrad',
    emoji: '🚗',
    products: [
      // Flüssigkeiten
      { id: 'motoroel', name: 'Motoröl', emoji: '🛢️', defaultQty: 1, defaultUnit: 'L' },
      { id: 'bremsflüssigkeit', name: 'Bremsflüssigkeit', emoji: '🛢️', defaultQty: 1, defaultUnit: 'L' },
      { id: 'kuehlerfrostschutz', name: 'Kühlerfrostschutz', emoji: '❄️', defaultQty: 1, defaultUnit: 'L' },
      { id: 'scheibenwischwasser', name: 'Scheibenwischwasser', emoji: '💧', defaultQty: 5, defaultUnit: 'L' },
      { id: 'scheibenfrostschutz', name: 'Scheibenfrostschutz', emoji: '❄️', defaultQty: 1, defaultUnit: 'L' },
      // Pflege
      { id: 'autoshampoo', name: 'Autoshampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'autowachs', name: 'Autowachs', emoji: '✨', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'felgenreiniger', name: 'Felgenreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'innenreiniger', name: 'Innenraumreiniger', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'lederpflege', name: 'Lederpflege', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'cockpitspray', name: 'Cockpitspray', emoji: '✨', defaultQty: 1, defaultUnit: 'Dose' },
      { id: 'mikrofasertuch-auto', name: 'Mikrofasertuch Auto', emoji: '🧽', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'schwamm-auto', name: 'Autoschwamm', emoji: '🧽', defaultQty: 1, defaultUnit: 'Stück' },
      // Zubehör
      { id: 'lufterfrischer', name: 'Lufterfrischer', emoji: '🌸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'eiskratzer', name: 'Eiskratzer', emoji: '❄️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schneebesen-auto', name: 'Schneebesen Auto', emoji: '❄️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'abschleppseil', name: 'Abschleppseil', emoji: '🪢', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'starthilfekabel', name: 'Starthilfekabel', emoji: '🔌', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'warndreieck', name: 'Warndreieck', emoji: '⚠️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'warnweste', name: 'Warnweste', emoji: '🦺', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'verbandskasten', name: 'Verbandskasten', emoji: '🩹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'handyhalterung', name: 'Handyhalterung', emoji: '📱', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sonnenschutz-auto', name: 'Sonnenschutz Auto', emoji: '☀️', defaultQty: 1, defaultUnit: 'Stück' },
      // Verschleiß
      { id: 'scheibenwischer', name: 'Scheibenwischer', emoji: '🚗', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'gluehbirne-auto', name: 'KFZ-Glühbirne', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'oelfilter', name: 'Ölfilter', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'luftfilter', name: 'Luftfilter', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ✅ v2.2: NEU - Schreibwaren & Schule
  'schule': {
    id: 'schule',
    label: 'Schule & Lernen',
    emoji: '📚',
    products: [
      // Hefte & Blöcke
      { id: 'schulheft-liniert', name: 'Schulheft liniert', emoji: '📓', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schulheft-kariert', name: 'Schulheft kariert', emoji: '📓', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'collegeblock', name: 'Collegeblock', emoji: '📒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'vokabelheft', name: 'Vokabelheft', emoji: '📕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'notenheft', name: 'Notenheft', emoji: '🎵', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zeichenblock', name: 'Zeichenblock', emoji: '🎨', defaultQty: 1, defaultUnit: 'Stück' },
      // Stifte
      { id: 'buntstifte', name: 'Buntstifte', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'filzstifte', name: 'Filzstifte', emoji: '🖊️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'fueller', name: 'Füller', emoji: '🖋️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'tintenpatronen', name: 'Tintenpatronen', emoji: '🖋️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'wachsmalstifte', name: 'Wachsmalstifte', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Set' },
      // Taschen & Zubehör
      { id: 'schulranzen', name: 'Schulranzen', emoji: '🎒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'federmäppchen', name: 'Federmäppchen', emoji: '✏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'turnbeutel', name: 'Turnbeutel', emoji: '👟', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'brotdose', name: 'Brotdose', emoji: '🥪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'trinkflasche-schule', name: 'Trinkflasche Schule', emoji: '🍶', defaultQty: 1, defaultUnit: 'Stück' },
      // Lernmaterial
      { id: 'taschenrechner', name: 'Taschenrechner', emoji: '🔢', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'woerterbuch', name: 'Wörterbuch', emoji: '📖', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'atlas', name: 'Atlas', emoji: '🗺️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lernkarten', name: 'Lernkarten/Karteikarten', emoji: '📇', defaultQty: 1, defaultUnit: 'Packung' },
      // Kunst & Basteln
      { id: 'wasserfarben', name: 'Wasserfarben', emoji: '🎨', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'pinsel-set', name: 'Pinsel-Set', emoji: '🖌️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'bastelschere', name: 'Bastelschere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'bastelpapier', name: 'Bastelpapier', emoji: '🎨', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tonpapier', name: 'Tonpapier', emoji: '🎨', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'bastelkleber', name: 'Bastelkleber', emoji: '🧴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'glitzer', name: 'Glitzer', emoji: '✨', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'knete', name: 'Knete/Modelliermasse', emoji: '🎨', defaultQty: 1, defaultUnit: 'Packung' },
    ]
  },

  // ✅ v2.2: NEU - Party & Deko
  'party-deko': {
    id: 'party-deko',
    label: 'Party & Deko',
    emoji: '🎉',
    products: [
      // Party-Basics
      { id: 'luftballons', name: 'Luftballons', emoji: '🎈', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'girlande', name: 'Girlande', emoji: '🎊', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'konfetti', name: 'Konfetti', emoji: '🎊', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'luftschlangen', name: 'Luftschlangen', emoji: '🎉', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'partyhut', name: 'Partyhüte', emoji: '🎩', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'tischdecke-party', name: 'Tischdecke Party', emoji: '🎪', defaultQty: 1, defaultUnit: 'Stück' },
      // Einweggeschirr
      { id: 'pappteller', name: 'Pappteller', emoji: '🍽️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'pappbecher', name: 'Pappbecher', emoji: '🥤', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'plastikbesteck', name: 'Einwegbesteck', emoji: '🍴', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'servietten-party', name: 'Servietten Party', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'strohhalme', name: 'Strohhalme', emoji: '🥤', defaultQty: 1, defaultUnit: 'Packung' },
      // Kerzen
      { id: 'geburtstagskerzen', name: 'Geburtstagskerzen', emoji: '🕯️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'wunderkerzen', name: 'Wunderkerzen', emoji: '✨', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'duftkerze', name: 'Duftkerze', emoji: '🕯️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'teelicht', name: 'Teelichter', emoji: '🕯️', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'stumpenkerze', name: 'Stumpenkerze', emoji: '🕯️', defaultQty: 1, defaultUnit: 'Stück' },
      // Deko
      { id: 'tischdeko', name: 'Tischdeko', emoji: '💐', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'banner', name: 'Banner/Wimpelkette', emoji: '🚩', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fotorequisiten', name: 'Foto-Requisiten', emoji: '📸', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'pinata', name: 'Piñata', emoji: '🪅', defaultQty: 1, defaultUnit: 'Stück' },
      // Wohndeko
      { id: 'bilderrahmen', name: 'Bilderrahmen', emoji: '🖼️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'vase', name: 'Vase', emoji: '🏺', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kunstblumen', name: 'Kunstblumen', emoji: '🌸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lichterkette-deko', name: 'Lichterkette Deko', emoji: '✨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wanddeko', name: 'Wanddeko', emoji: '🖼️', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ✅ v2.2: NEU - Möbel & Wohnen
  'moebel-wohnen': {
    id: 'moebel-wohnen',
    label: 'Möbel & Wohnen',
    emoji: '🛋️',
    products: [
      // Aufbewahrung
      { id: 'aufbewahrungsbox', name: 'Aufbewahrungsbox', emoji: '📦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'korb', name: 'Aufbewahrungskorb', emoji: '🧺', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'regal', name: 'Regal', emoji: '🗄️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schubladenbox', name: 'Schubladenbox', emoji: '🗃️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'vakuumbeutel', name: 'Vakuumbeutel', emoji: '📦', defaultQty: 1, defaultUnit: 'Packung' },
      // Kleidung
      { id: 'kleiderbuegel', name: 'Kleiderbügel', emoji: '🧥', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'schuhschrank', name: 'Schuhregal', emoji: '👟', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kleiderhaken', name: 'Kleiderhaken', emoji: '🪝', defaultQty: 1, defaultUnit: 'Packung' },
      // Textilien
      { id: 'kissen', name: 'Kissen', emoji: '🛋️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kissenbezug', name: 'Kissenbezug', emoji: '🛋️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'decke', name: 'Decke/Plaid', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'teppich', name: 'Teppich', emoji: '🧹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fussmatte', name: 'Fußmatte', emoji: '🚪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'vorhang', name: 'Vorhang', emoji: '🪟', defaultQty: 1, defaultUnit: 'Stück' },
      // Küche
      { id: 'schneidebrett', name: 'Schneidebrett', emoji: '🔪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'geschirrtuch', name: 'Geschirrtuch', emoji: '🧴', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'topflappen', name: 'Topflappen', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'abtropfgestell', name: 'Abtropfgestell', emoji: '🍽️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'muelleimer', name: 'Mülleimer', emoji: '🗑️', defaultQty: 1, defaultUnit: 'Stück' },
      // Bad
      { id: 'duschvorhang', name: 'Duschvorhang', emoji: '🚿', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'badezimmerteppich', name: 'Badezimmerteppich', emoji: '🛁', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zahnbuerstenhalter', name: 'Zahnbürstenhalter', emoji: '🪥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'seifenspender', name: 'Seifenspender', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wäschekorb', name: 'Wäschekorb', emoji: '🧺', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ✅ v2.2: NEU - Saisonware
  'saison': {
    id: 'saison',
    label: 'Saisonware',
    emoji: '🎄',
    products: [
      // Sommer
      { id: 'sonnencreme', name: 'Sonnencreme', emoji: '☀️', defaultQty: 1, defaultUnit: 'Tube' },
      { id: 'after-sun', name: 'After-Sun Lotion', emoji: '🌴', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'sonnenbrille', name: 'Sonnenbrille', emoji: '🕶️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sonnenschirm', name: 'Sonnenschirm', emoji: '⛱️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'strandtuch', name: 'Strandtuch', emoji: '🏖️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schwimmreifen', name: 'Schwimmreifen', emoji: '🛟', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'luftmatratze', name: 'Luftmatratze', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'planschbecken', name: 'Planschbecken', emoji: '🏊', defaultQty: 1, defaultUnit: 'Stück' },
      // Grillen
      { id: 'grillkohle', name: 'Grillkohle', emoji: '🔥', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'grillanzuender', name: 'Grillanzünder', emoji: '🔥', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'grillbesteck', name: 'Grillbesteck', emoji: '🍖', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'grillzange', name: 'Grillzange', emoji: '🥩', defaultQty: 1, defaultUnit: 'Stück' },
      // Winter
      { id: 'streusalz', name: 'Streusalz', emoji: '❄️', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'schneeschieber', name: 'Schneeschieber', emoji: '❄️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'winterhandschuhe', name: 'Winterhandschuhe', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'muetze', name: 'Mütze', emoji: '🧢', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schal', name: 'Schal', emoji: '🧣', defaultQty: 1, defaultUnit: 'Stück' },
      // Weihnachten
      { id: 'weihnachtsbaum', name: 'Weihnachtsbaum', emoji: '🎄', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'christbaumkugeln', name: 'Christbaumkugeln', emoji: '🎄', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'lichterkette-weihnacht', name: 'Lichterkette Weihnachten', emoji: '✨', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'adventskalender', name: 'Adventskalender', emoji: '🎁', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'geschenkpapier', name: 'Geschenkpapier', emoji: '🎁', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'geschenkband', name: 'Geschenkband', emoji: '🎀', defaultQty: 1, defaultUnit: 'Rolle' },
      // Ostern
      { id: 'ostereier', name: 'Ostereier-Farben', emoji: '🥚', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'osternest', name: 'Osternest/Osterkorb', emoji: '🐰', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'osterdeko', name: 'Osterdeko', emoji: '🐣', defaultQty: 1, defaultUnit: 'Set' },
    ]
  },

  // ============================================================================
  // ✅ v2.3: WEITERE KATEGORIEN (7 neue)
  // ============================================================================

  // 🧳 REISE & GEPÄCK
  'reise': {
    id: 'reise',
    label: 'Reise & Gepäck',
    emoji: '🧳',
    products: [
      // Gepäck
      { id: 'koffer', name: 'Koffer', emoji: '🧳', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'reisetasche', name: 'Reisetasche', emoji: '👜', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rucksack-reise', name: 'Reiserucksack', emoji: '🎒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kulturbeutel', name: 'Kulturbeutel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'packtaschen', name: 'Packtaschen/Packing Cubes', emoji: '📦', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'kofferanhaenger', name: 'Kofferanhänger', emoji: '🏷️', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'kofferschloss', name: 'Kofferschloss', emoji: '🔒', defaultQty: 1, defaultUnit: 'Stück' },
      // Reise-Accessoires
      { id: 'reisekissen', name: 'Reisekissen', emoji: '💤', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schlafmaske', name: 'Schlafmaske', emoji: '😴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ohrstoepsel', name: 'Ohrstöpsel', emoji: '👂', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'reiseadapter', name: 'Reiseadapter', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'powerbank', name: 'Powerbank', emoji: '🔋', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'reise-waeschebeutel', name: 'Wäschebeutel', emoji: '👕', defaultQty: 1, defaultUnit: 'Stück' },
      // Reise-Hygiene (Reisegrößen)
      { id: 'reise-shampoo', name: 'Reise-Shampoo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'reise-zahnpasta', name: 'Reise-Zahnpasta', emoji: '🦷', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'reise-deo', name: 'Reise-Deo', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'desinfektionsgel', name: 'Desinfektionsgel', emoji: '🧴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'reiseapotheke', name: 'Reiseapotheke', emoji: '💊', defaultQty: 1, defaultUnit: 'Set' },
      // Dokumente
      { id: 'reisepasshuelle', name: 'Reisepasshülle', emoji: '📕', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'dokumententasche', name: 'Dokumententasche', emoji: '📁', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'geldguertel', name: 'Geldgürtel/Brustbeutel', emoji: '💰', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // 🎮 SPIELZEUG & SPIELE
  'spielzeug': {
    id: 'spielzeug',
    label: 'Spielzeug & Spiele',
    emoji: '🎮',
    products: [
      // Klassiker
      { id: 'puzzle', name: 'Puzzle', emoji: '🧩', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'brettspiel', name: 'Brettspiel', emoji: '🎲', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kartenspiel', name: 'Kartenspiel', emoji: '🃏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wuerfel', name: 'Würfel', emoji: '🎲', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'schach', name: 'Schachspiel', emoji: '♟️', defaultQty: 1, defaultUnit: 'Stück' },
      // Kreativ
      { id: 'lego', name: 'LEGO/Bausteine', emoji: '🧱', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'knete', name: 'Knete/Play-Doh', emoji: '🎨', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'malbuch', name: 'Malbuch', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'buntstifte', name: 'Buntstifte', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'bastelset', name: 'Bastelset', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      // Outdoor
      { id: 'ball-spielzeug', name: 'Spielball', emoji: '⚽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'springseil', name: 'Springseil', emoji: '🏃', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'frisbee', name: 'Frisbee', emoji: '🥏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'seifenblasen', name: 'Seifenblasen', emoji: '🫧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'drachen', name: 'Drachen', emoji: '🪁', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sandspielzeug', name: 'Sandspielzeug', emoji: '🏖️', defaultQty: 1, defaultUnit: 'Set' },
      // Puppen & Figuren
      { id: 'puppe', name: 'Puppe', emoji: '🪆', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'actionfigur', name: 'Actionfigur', emoji: '🦸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'stofftier', name: 'Stofftier/Kuscheltier', emoji: '🧸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'puppenhaus', name: 'Puppenhaus', emoji: '🏠', defaultQty: 1, defaultUnit: 'Stück' },
      // Fahrzeuge
      { id: 'spielzeugauto', name: 'Spielzeugauto', emoji: '🚗', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'modelleisenbahn', name: 'Modelleisenbahn', emoji: '🚂', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'ferngesteuertes-auto', name: 'RC-Auto', emoji: '🏎️', defaultQty: 1, defaultUnit: 'Stück' },
      // Elektronisch
      { id: 'videospiel', name: 'Videospiel', emoji: '🎮', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'konsole-controller', name: 'Controller', emoji: '🎮', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // 🎸 MUSIK & INSTRUMENTE
  'musik': {
    id: 'musik',
    label: 'Musik & Instrumente',
    emoji: '🎸',
    products: [
      // Saiteninstrumente
      { id: 'gitarrensaiten', name: 'Gitarrensaiten', emoji: '🎸', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'gitarrenplektren', name: 'Plektren', emoji: '🎸', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'kapodaster', name: 'Kapodaster', emoji: '🎸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gitarrengurt', name: 'Gitarrengurt', emoji: '🎸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gitarrenstaender', name: 'Gitarrenständer', emoji: '🎸', defaultQty: 1, defaultUnit: 'Stück' },
      // Blasinstrumente
      { id: 'mundharmonika', name: 'Mundharmonika', emoji: '🎶', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'floete', name: 'Blockflöte', emoji: '🎵', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'saxophon-blaetter', name: 'Saxophon-Blätter', emoji: '🎷', defaultQty: 1, defaultUnit: 'Packung' },
      // Schlaginstrumente
      { id: 'drumsticks', name: 'Drumsticks', emoji: '🥁', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'schlagzeugfelle', name: 'Schlagzeugfelle', emoji: '🥁', defaultQty: 1, defaultUnit: 'Stück' },
      // Tasten
      { id: 'notenhefte', name: 'Notenhefte', emoji: '🎹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'keyboard-staender', name: 'Keyboard-Ständer', emoji: '🎹', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sustain-pedal', name: 'Sustain-Pedal', emoji: '🎹', defaultQty: 1, defaultUnit: 'Stück' },
      // Zubehör allgemein
      { id: 'stimmgeraet', name: 'Stimmgerät', emoji: '🎼', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'metronom', name: 'Metronom', emoji: '⏱️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'notenstaender', name: 'Notenständer', emoji: '🎼', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'instrumentenpflege', name: 'Instrumentenpflege', emoji: '✨', defaultQty: 1, defaultUnit: 'Set' },
      // Audio
      { id: 'kopfhoerer-musik', name: 'Kopfhörer (Studio)', emoji: '🎧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'audiokabel', name: 'Audiokabel (Klinke)', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mikrofon', name: 'Mikrofon', emoji: '🎤', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'mikrofonstaender', name: 'Mikrofonständer', emoji: '🎤', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // 🌻 GARTEN ERWEITERT
  'garten-erweitert': {
    id: 'garten-erweitert',
    label: 'Garten (erweitert)',
    emoji: '🌻',
    products: [
      // Pflanzen
      { id: 'blumensamen', name: 'Blumensamen', emoji: '🌸', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'gemuesesamen', name: 'Gemüsesamen', emoji: '🥕', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'krautersamen', name: 'Kräutersamen', emoji: '🌿', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'blumenzwiebeln', name: 'Blumenzwiebeln', emoji: '🌷', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'stauden', name: 'Stauden', emoji: '🌼', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'obstbaum', name: 'Obstbaum', emoji: '🍎', defaultQty: 1, defaultUnit: 'Stück' },
      // Erde & Dünger
      { id: 'blumenerde', name: 'Blumenerde', emoji: '🪴', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'komposterde', name: 'Komposterde', emoji: '🌱', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'rasenerde', name: 'Rasenerde', emoji: '🌿', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'duenger-fluessig', name: 'Flüssigdünger', emoji: '💧', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'langzeitduenger', name: 'Langzeitdünger', emoji: '🌱', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'rasenduenger', name: 'Rasendünger', emoji: '🌿', defaultQty: 1, defaultUnit: 'Sack' },
      { id: 'kompostbeschleuniger', name: 'Kompostbeschleuniger', emoji: '♻️', defaultQty: 1, defaultUnit: 'Packung' },
      // Bewässerung
      { id: 'gartenschlauch', name: 'Gartenschlauch', emoji: '💧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schlauchaufsatz', name: 'Schlauchaufsatz/Brause', emoji: '🚿', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rasensprenger', name: 'Rasensprenger', emoji: '💦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'giesskanne', name: 'Gießkanne', emoji: '🪣', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'bewaesserungssystem', name: 'Bewässerungssystem', emoji: '💧', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'regentonne', name: 'Regentonne', emoji: '🛢️', defaultQty: 1, defaultUnit: 'Stück' },
      // Werkzeug
      { id: 'rasenmaeher', name: 'Rasenmäher', emoji: '🌿', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'heckenschere', name: 'Heckenschere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gartenschere', name: 'Gartenschere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rechen', name: 'Rechen', emoji: '🍂', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schubkarre', name: 'Schubkarre', emoji: '🛒', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gartenhandschuhe', name: 'Gartenhandschuhe', emoji: '🧤', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'knieschuetzer', name: 'Knieschützer', emoji: '🦵', defaultQty: 1, defaultUnit: 'Paar' },
      // Schädlingsbekämpfung
      { id: 'schneckenkorn', name: 'Schneckenkorn', emoji: '🐌', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'unkrautvernichter', name: 'Unkrautvernichter', emoji: '🌿', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'insektizid', name: 'Insektizid (bio)', emoji: '🐛', defaultQty: 1, defaultUnit: 'Flasche' },
      { id: 'nuetzlinge', name: 'Nützlinge (Marienkäfer)', emoji: '🐞', defaultQty: 1, defaultUnit: 'Packung' },
      // Möbel & Deko
      { id: 'blumenkasten', name: 'Blumenkasten', emoji: '🌸', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'pflanzkuebel', name: 'Pflanzkübel', emoji: '🪴', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'rankhilfe', name: 'Rankhilfe', emoji: '🌱', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gartenliege', name: 'Gartenliege', emoji: '🛋️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sonnenschirm', name: 'Sonnenschirm', emoji: '☂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'solar-gartenleuchte', name: 'Solar-Gartenleuchte', emoji: '💡', defaultQty: 1, defaultUnit: 'Set' },
    ]
  },

  // ⚡ HEIMWERKER-ELEKTRIK
  'elektrik': {
    id: 'elektrik',
    label: 'Heimwerker-Elektrik',
    emoji: '⚡',
    products: [
      // Grundlagen
      { id: 'luesterklemmen', name: 'Lüsterklemmen', emoji: '🔌', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'wago-klemmen', name: 'WAGO-Klemmen', emoji: '🔌', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'aderendhuelsen', name: 'Aderendhülsen', emoji: '🔌', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'kabelbinder', name: 'Kabelbinder', emoji: '🔗', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'isolierband', name: 'Isolierband', emoji: '🔌', defaultQty: 1, defaultUnit: 'Rolle' },
      { id: 'schrumpfschlauch', name: 'Schrumpfschlauch', emoji: '🔌', defaultQty: 1, defaultUnit: 'Set' },
      // Kabel
      { id: 'nym-kabel', name: 'NYM-Kabel', emoji: '🔌', defaultQty: 10, defaultUnit: 'Meter' },
      { id: 'h07v-kabel', name: 'H07V-Einzelader', emoji: '🔌', defaultQty: 10, defaultUnit: 'Meter' },
      { id: 'lautsprecherkabel', name: 'Lautsprecherkabel', emoji: '🔊', defaultQty: 10, defaultUnit: 'Meter' },
      { id: 'netzwerkkabel-rolle', name: 'Netzwerkkabel (Rolle)', emoji: '🌐', defaultQty: 25, defaultUnit: 'Meter' },
      { id: 'koaxialkabel', name: 'Koaxialkabel', emoji: '📺', defaultQty: 5, defaultUnit: 'Meter' },
      // Steckdosen & Schalter
      { id: 'steckdose', name: 'Unterputz-Steckdose', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'doppelsteckdose', name: 'Doppelsteckdose', emoji: '🔌', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'lichtschalter', name: 'Lichtschalter', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wechselschalter', name: 'Wechselschalter', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'dimmer', name: 'Dimmer', emoji: '💡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'bewegungsmelder', name: 'Bewegungsmelder', emoji: '👁️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zeitschaltuhr', name: 'Zeitschaltuhr', emoji: '⏰', defaultQty: 1, defaultUnit: 'Stück' },
      // Unterputz
      { id: 'schalterdose', name: 'Schalterdose (UP)', emoji: '📦', defaultQty: 5, defaultUnit: 'Stück' },
      { id: 'abzweigdose', name: 'Abzweigdose', emoji: '📦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'hohlwanddose', name: 'Hohlwanddose', emoji: '📦', defaultQty: 5, defaultUnit: 'Stück' },
      { id: 'kabelkanal', name: 'Kabelkanal', emoji: '📦', defaultQty: 2, defaultUnit: 'Meter' },
      { id: 'leerrohr', name: 'Leerrohr/Installationsrohr', emoji: '🔧', defaultQty: 10, defaultUnit: 'Meter' },
      // Sicherheit
      { id: 'sicherung', name: 'Sicherung (Automat)', emoji: '⚡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'fi-schalter', name: 'FI-Schalter', emoji: '⚡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'ueberspannungsschutz', name: 'Überspannungsschutz', emoji: '⚡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'phasenpruefer', name: 'Phasenprüfer', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      // Werkzeug
      { id: 'abisolierzange', name: 'Abisolierzange', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'crimpzange', name: 'Crimpzange', emoji: '🔧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'spannungspruefer', name: 'Spannungsprüfer (Digital)', emoji: '📊', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'leitungssucher', name: 'Leitungssucher', emoji: '📡', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // 🧵 TEXTILIEN & NÄHEN
  'textilien': {
    id: 'textilien',
    label: 'Textilien & Nähen',
    emoji: '🧵',
    products: [
      // Nähzubehör
      { id: 'naehgarn', name: 'Nähgarn', emoji: '🧵', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'naehnadeln', name: 'Nähnadeln', emoji: '🪡', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'stecknadeln', name: 'Stecknadeln', emoji: '📍', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'sicherheitsnadeln', name: 'Sicherheitsnadeln', emoji: '🧷', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'naehmaschinen-nadeln', name: 'Nähmaschinennadeln', emoji: '🪡', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'stoffschere', name: 'Stoffschere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zickzackschere', name: 'Zickzackschere', emoji: '✂️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'nahttrenner', name: 'Nahttrenner', emoji: '🔪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'massband', name: 'Maßband', emoji: '📏', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schneiderkreide', name: 'Schneiderkreide', emoji: '🖍️', defaultQty: 1, defaultUnit: 'Set' },
      // Verschlüsse
      { id: 'reissverschluss', name: 'Reißverschluss', emoji: '🔗', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'knoepfe', name: 'Knöpfe', emoji: '🔘', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'druckknoepfe', name: 'Druckknöpfe', emoji: '🔘', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'klettverschluss', name: 'Klettverschluss', emoji: '🔗', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'haken-oesen', name: 'Haken & Ösen', emoji: '🪝', defaultQty: 1, defaultUnit: 'Set' },
      // Bänder & Borten
      { id: 'gummiband', name: 'Gummiband', emoji: '🔗', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'schraeband', name: 'Schrägband', emoji: '🎀', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'spitze', name: 'Spitzenband', emoji: '🎀', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'satinband', name: 'Satinband', emoji: '🎀', defaultQty: 1, defaultUnit: 'Meter' },
      // Stoffe
      { id: 'baumwollstoff', name: 'Baumwollstoff', emoji: '🧶', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'jerseystoff', name: 'Jerseystoff', emoji: '🧶', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'fleecestoff', name: 'Fleecestoff', emoji: '🧶', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'futterstoff', name: 'Futterstoff', emoji: '🧶', defaultQty: 1, defaultUnit: 'Meter' },
      { id: 'vlieseline', name: 'Vlieseline (Einlage)', emoji: '📄', defaultQty: 1, defaultUnit: 'Meter' },
      // Handarbeit
      { id: 'wolle', name: 'Wolle', emoji: '🧶', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'hakelnadel', name: 'Häkelnadel', emoji: '🪡', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'stricknadeln', name: 'Stricknadeln', emoji: '🪡', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'stickgarn', name: 'Stickgarn', emoji: '🧵', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'stickrahmen', name: 'Stickrahmen', emoji: '⭕', defaultQty: 1, defaultUnit: 'Stück' },
    ]
  },

  // ⛺ CAMPING & OUTDOOR
  'camping': {
    id: 'camping',
    label: 'Camping & Outdoor',
    emoji: '⛺',
    products: [
      // Unterkunft
      { id: 'zelt', name: 'Zelt', emoji: '⛺', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'zeltheringe', name: 'Zeltheringe', emoji: '📍', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'isomatte', name: 'Isomatte', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'luftmatratze', name: 'Luftmatratze', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'schlafsack', name: 'Schlafsack', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'campingliege', name: 'Campingliege/Feldbett', emoji: '🛏️', defaultQty: 1, defaultUnit: 'Stück' },
      // Kochen
      { id: 'campingkocher', name: 'Campingkocher', emoji: '🔥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'gaskartuschen', name: 'Gaskartuschen', emoji: '🔥', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'campinggeschirr', name: 'Campinggeschirr', emoji: '🍽️', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'campingbesteck', name: 'Campingbesteck', emoji: '🍴', defaultQty: 1, defaultUnit: 'Set' },
      { id: 'kuehlbox', name: 'Kühlbox', emoji: '❄️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kuehlakkus', name: 'Kühlakkus', emoji: '❄️', defaultQty: 2, defaultUnit: 'Stück' },
      { id: 'wasserkanister', name: 'Wasserkanister', emoji: '💧', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'thermoskanne', name: 'Thermoskanne', emoji: '☕', defaultQty: 1, defaultUnit: 'Stück' },
      // Möbel
      { id: 'campingstuhl', name: 'Campingstuhl', emoji: '🪑', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'campingtisch', name: 'Campingtisch', emoji: '🪑', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'picknickdecke', name: 'Picknickdecke', emoji: '🧺', defaultQty: 1, defaultUnit: 'Stück' },
      // Licht & Strom
      { id: 'stirnlampe', name: 'Stirnlampe', emoji: '🔦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'campinglaterne', name: 'Campinglaterne', emoji: '🏮', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'taschenlampe', name: 'Taschenlampe', emoji: '🔦', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'solar-ladegeraet', name: 'Solar-Ladegerät', emoji: '☀️', defaultQty: 1, defaultUnit: 'Stück' },
      // Werkzeug & Sicherheit
      { id: 'taschenmesser', name: 'Taschenmesser/Multitool', emoji: '🔪', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'kompass', name: 'Kompass', emoji: '🧭', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'erste-hilfe-outdoor', name: 'Erste-Hilfe-Set (Outdoor)', emoji: '⛑️', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'notfallpfeife', name: 'Notfallpfeife', emoji: '📣', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'feuerstahl', name: 'Feuerstahl', emoji: '🔥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'paracord', name: 'Paracord-Seil', emoji: '🪢', defaultQty: 10, defaultUnit: 'Meter' },
      // Hygiene
      { id: 'campingdusche', name: 'Campingdusche', emoji: '🚿', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'campingtoilette', name: 'Campingtoilette', emoji: '🚽', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'bio-toilettenpapier', name: 'Bio-Toilettenpapier', emoji: '🧻', defaultQty: 1, defaultUnit: 'Packung' },
      { id: 'outdoorseife', name: 'Outdoorseife (bio)', emoji: '🧼', defaultQty: 1, defaultUnit: 'Stück' },
      // Kleidung
      { id: 'regenjacke', name: 'Regenjacke', emoji: '🧥', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'wanderschuhe', name: 'Wanderschuhe', emoji: '🥾', defaultQty: 1, defaultUnit: 'Paar' },
      { id: 'trekkingsocken', name: 'Trekkingsocken', emoji: '🧦', defaultQty: 2, defaultUnit: 'Paar' },
      { id: 'mueckenschutz', name: 'Mückenschutz', emoji: '🦟', defaultQty: 1, defaultUnit: 'Stück' },
      { id: 'sonnenschutz-outdoor', name: 'Sonnencreme (LSF 50)', emoji: '☀️', defaultQty: 1, defaultUnit: 'Tube' },
    ]
  },
};

// Flache Liste aller Produkte für Suche
export const ALL_PRODUCTS = Object.values(PRODUCT_CATALOG).flatMap(category =>
  category.products.map(product => ({
    ...product,
    categoryId: category.id,
    categoryLabel: category.label,
    categoryEmoji: category.emoji,
  }))
);

// Häufig gekaufte Produkte (Standardauswahl) - erweitert
export const FREQUENT_PRODUCTS = [
  'milch', 'brot', 'eier', 'butter', 'kaese', 'banane', 'apfel',
  'kartoffel', 'tomate', 'zwiebel', 'nudeln', 'reis', 'toilettenpapier',
  'joghurt', 'gurke', 'paprika', 'hackfleisch', 'haehnchen', 'lachs',
  'wasser', 'kaffee', 'zucker', 'mehl', 'olivenoel', 'sahne'
];

// Einheiten für Mengenauswahl - erweitert v2.1
export const UNITS = [
  'Stück',
  'g',
  'kg',
  'ml',
  'L',
  'Packung',
  'Dose',
  'Dosen',
  'Flasche',
  'Flaschen',
  'Glas',
  'Tube',
  'Rolle',
  'Bund',
  'Tüte',
  'Tafel',
  'Topf',
  'Paar',
  'Becher',
  'Beutel',
  // ✅ v2.1: Neue Einheiten für Baumarkt & Elektro
  'Set',
  'Kartusche',
  'Eimer',
  'Sack',
  'Meter'
];

// Helper: Produkt nach ID finden
export const getProductById = (productId) => {
  return ALL_PRODUCTS.find(p => p.id === productId);
};

// Helper: Produkte durchsuchen
export const searchProducts = (query) => {
  if (!query || query.trim().length < 2) return [];

  const lowerQuery = query.toLowerCase().trim();

  return ALL_PRODUCTS.filter(product =>
    product.name.toLowerCase().includes(lowerQuery) ||
    product.categoryLabel.toLowerCase().includes(lowerQuery)
  ).slice(0, 30); // Max 30 Ergebnisse (erhöht von 20)
};

// Helper: Häufig gekaufte Produkte holen
export const getFrequentProducts = () => {
  return FREQUENT_PRODUCTS
    .map(id => getProductById(id))
    .filter(Boolean);
};

console.log('📦 ProductCatalog v2.3 loaded -', ALL_PRODUCTS.length, 'products in', Object.keys(PRODUCT_CATALOG).length, 'categories');
